import objectFitImages from 'object-fit-images';

// import './_blog-feed.js';
import './_modal-popup.js';
//import './_foundation.js';

objectFitImages();
